module.exports = __webpack_public_path__ + "static/media/prüf_active.8036b11a.jpg";